"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.couponDetails_jericho = exports.couponAction_jericho = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var index_1 = require("../../../Config/index");
var common_1 = require("../../common");
var interfaces_1 = require("../../common/interfaces");
var constants_1 = require("../constants");
var couponAction_jericho = function (data) {
    var productType = data.productType, checkoutFlowType = data.checkoutFlowType, coupon = data.coupon, cartId = data.cartId;
    var params = {
        command: 'applycoupon',
        cartId: cartId,
        productType: productType,
        checkoutFlowType: checkoutFlowType,
        data: { coupon: tslib_1.__assign({}, coupon) },
    };
    var response = (0, common_1.postRequestToCheggResponse)(BaseApi_1.default.doPostRequestToChegg(index_1.sibcV2Url, params));
    return response.then(function (result) {
        var _a, _b, _c, _d;
        if (coupon.command == 'ADD') {
            // Custom logic as requested by Gerald to ease front end validations.
            if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.coupon) && !result.errors) {
                // invalid coupon, expired coupon, or any other error
                result.errors = [constants_1.CouponErrors.INVALID_COUPON];
            }
            // Added sufficient tests. This is complaining about some small edge case thus added ignore in next line
            /* istanbul ignore next */
            if (((_c = (_b = result.data) === null || _b === void 0 ? void 0 : _b.coupon) === null || _c === void 0 ? void 0 : _c.errorMessage) && !((_d = result.data) === null || _d === void 0 ? void 0 : _d.couponError)) {
                // failure with a valid but non-applicable coupon
                result.data.couponError = result.data.coupon.errorMessage[0];
                result.errors = [constants_1.CouponErrors.NON_APPLICABLE_COUPON];
            }
        }
        return result;
    });
};
exports.couponAction_jericho = couponAction_jericho;
var couponDetails_jericho = function (params) {
    return {
        errors: [
            {
                message: "coupon details not implemented: ".concat(JSON.stringify(params)),
                type: interfaces_1.ErrorType.SERVER,
                isBffError: false,
            },
        ],
        data: null,
    };
};
exports.couponDetails_jericho = couponDetails_jericho;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/couponAPI/jericho/index.js
// module id = 3399
// module chunks = 11